<template>
  <div style="width: 100vw;height: 100vh;background-color: #F3F5F9;">
            <img class="loginBackImg" src="../../assets/am-login-bg.png">
    <div
        style="box-sizing: border-box;padding-left: 60px;padding-right:60px;margin-left: 33vw;width: 33vw;height: 100%;display: flex;flex-direction: column;justify-content: center;background-color: white;  position: absolute;">

      <img class="loginLogo" src="../../assets/am-logo.png">

      <div class="login-title" style="margin-top: 30px">Email</div>
      <input class="login-input" v-model="form.account_name"/>

      <div class="login-title" style="margin-top: 30px">Login Type</div>
      <div class="login-input1">
          <el-select type="text" :popper-append-to-body="false" class="loginInput" placeholder="Identity" v-model="form.type" style="width:100%">
              <el-option value="学生" label="Student"></el-option>
              <el-option value="讲师" label="Lecturer"></el-option>
              <el-option value="助教" label="Teaching Assistant"></el-option>
          </el-select>
      </div>

      <div class="login-title" style="margin-top: 30px">Login Method</div>
      <div class="login-method">
          <el-radio-group v-model="loginMethod">
            <el-radio label="otp">OTP Code</el-radio>
            <el-radio label="password">Password</el-radio>
          </el-radio-group>
      </div>

      <template v-if="loginMethod === 'otp'">
        <div class="login-title" style="margin-top: 30px">Verification Code</div>
        <div class="otp-input-wrapper">
          <input class="login-input otp-input" v-model="form.verify_code" placeholder="Enter code"/>
          <el-button class="send-code-btn" :disabled="countdown > 0" @click="sendCode">
            {{ countdown > 0 ? `Resend (${countdown}s)` : 'Send Code' }}
          </el-button>
        </div>
      </template>

      <template v-else>
        <div class="login-title" style="margin-top: 30px">Password</div>
        <input type="password" class="login-input" v-model="form.account_pwd"/>
      </template>

      <div style="margin-top: 40px;position: relative">
        <div style="position: absolute;right: 0">
          <img @click="submit" src="../../assets/login-arrow.png" style="cursor: pointer;width: 3vw;height: auto">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {loginByEducator, loginByStudent, loginByEmployee, createLoginOPT, loginByStudentWithOPT, loginByEducatorWithOPT, loginByEmployeeWithOPT, verifyCrossLoginToken} from '../../api/index'
import {
  setUserId,
  setUserName,
  setUserEmail,
  removeUserEmail,
  setUserType,
  setProjectCode,
  setProjectName,
  setProjectEname,
  setApplicationExtraEvents,
  setAppId,
  setAccountName,
  setApplicationEvents, setAvatarUrl,logout
} from '../../utils/store'
import '../../assets/common/font.css'
export default {
  name: 'Login',
  data() {
    return {
      form: {
        account_name: '',
        account_pwd: '',
        verify_code: '',
        type: '学生'
      },
      loginMethod: 'otp',
      countdown: 0,
      countdownTimer: null
    }
  },
  mounted() {
    const query = this.$route.query
    if (query.cross_token && query.user_id) {
      this.handleCrossLogin(query.cross_token, query.user_id, query.user_type || 'student')
      return
    }
    logout()
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    handleCrossLogin(cross_token, user_id, user_type) {
      const preferredProjectCode = String(this.$route.query.project_code || '').trim()
      verifyCrossLoginToken(cross_token, user_id, user_type, preferredProjectCode).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data
          if (preferredProjectCode) {
            data = Object.assign({}, data, { project_code: preferredProjectCode })
          }
          if (user_type === 'student') {
            this.handleStudentLoginSuccess(data, { preferredProjectCode })
          } else if (user_type === 'educator' || user_type === 'advisor') {
            setUserId(data._id.$id)
            setUserName(data.educator_first_name + data.educator_last_name)
            setUserType('educator')
            this.$router.push('/teacherlist')
          } else if (user_type === 'employee') {
            setUserId(data._id.$id)
            setUserType('employee')
            setUserName(data.user_lastName + data.user_givenName)
            this.$router.push('/employeelist')
          } else if (user_type === 'schoolAdmin') {
            this.handleStudentLoginSuccess(data, { preferredProjectCode })
          }
          this.$message({ message: 'login success', type: 'success' })
        } else {
          this.$message.warning(res.data.msg || 'Cross login failed, please login manually')
          logout()
        }
      }).catch(() => {
        this.$message.error('Cross login failed, please login manually')
        logout()
      })
    },
    sendCode() {
      if (!this.form.account_name) {
        this.$message.error('Please input email')
        return
      }
      if (this.countdown > 0) return

      let login_type = 'student'
      if (this.form.type === '讲师') login_type = 'educator'
      else if (this.form.type === '助教') login_type = 'employee'

      createLoginOPT(this.form.account_name, login_type).then(res => {
        if (res.data.code === 0) {
          this.$message.success('Verification code sent successfully')
          this.countdown = 60
          this.countdownTimer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              clearInterval(this.countdownTimer)
              this.countdownTimer = null
            }
          }, 1000)
        } else {
          this.$message.error(res.data.msg || 'Failed to send code')
        }
      })
    },
    handleStudentLoginSuccess(result, options = {}) {
      this.$message({ message: 'login success', type: 'success' })
      var application_extra_events = result.application_extra_events
      // Prefer the project selected in EAE jump URL over whichever application
      // the login API happened to return first for multi-project students.
      const preferredProjectCode = String(
        (options && options.preferredProjectCode) ||
        this.$route.query.project_code ||
        ''
      ).trim()
      let project_code = preferredProjectCode || result.project_code
      let project_name = result.project_name
      let project_ename = result.project_ename
      if (preferredProjectCode && preferredProjectCode !== result.project_code) {
        // Keep names aligned when backend could not resolve the preferred project.
        if (!project_name || result.project_code !== preferredProjectCode) {
          project_name = preferredProjectCode
        }
        if (!project_ename || result.project_code !== preferredProjectCode) {
          project_ename = preferredProjectCode
        }
      }
      if (project_code) setProjectCode(project_code)
      if (project_name) setProjectName(project_name)
      if (project_ename) setProjectEname(project_ename)
      setApplicationExtraEvents(application_extra_events)
      var application_events = result.application_events
      setApplicationEvents(application_events)
      var app_id = result._id.$id
      setAppId(app_id)
      var account_name = result['student_info']['account_name']
      setAccountName(account_name)
      var student_email = String(result.student_info.student_email || result.student_info.email || '').trim()
      if (!student_email && /@/.test(this.form.account_name || '')) {
        student_email = String(this.form.account_name).trim()
      }
      if (student_email) {
        setUserEmail(student_email)
      } else {
        removeUserEmail()
      }
      var avatar_url = result['student_info']['avatar_url']
      setAvatarUrl(avatar_url)
      setUserId(result.student_id)
      setUserType('student')
      var student_name = result.student_info.student_lastName + ' ' + result.student_info.student_givenName
      setUserName(student_name)
      this.$router.push('/home')
    },
    submit() {
      if (!this.form.account_name) {
        this.$message.error('Please input email')
        return
      }

      if (this.loginMethod === 'otp') {
        if (!this.form.verify_code) {
          this.$message.error('Please input verification code')
          return
        }
        this.submitWithOPT()
      } else {
        if (!this.form.account_pwd) {
          this.$message.error('Please input password')
          return
        }
        this.submitWithPassword()
      }
    },
    submitWithOPT() {
      if (this.form.type === '讲师') {
        loginByEducatorWithOPT(this.form.account_name, this.form.verify_code).then(res => {
          if (res.data.code == 0) {
            this.$message({ message: 'login success', type: 'success' })
            setUserId(res.data.data._id.$id)
            setUserName(res.data.data.educator_first_name + res.data.data.educator_last_name)
            setUserType('educator')
            this.$router.push('/teacherlist')
          } else {
            this.$message.warning(res.data.msg || 'Login failed')
          }
        })
      } else if (this.form.type === '学生') {
        loginByStudentWithOPT(this.form.account_name, this.form.verify_code).then(res => {
          if (res.data.code == 0) {
            this.handleStudentLoginSuccess(res.data.data)
          } else {
            this.$message.warning('Login failed: ' + res.data.msg)
          }
        })
      } else if (this.form.type === '助教') {
        loginByEmployeeWithOPT(this.form.account_name, this.form.verify_code).then(res => {
          if (res.data.code == 0) {
            this.$message({ message: 'login success', type: 'success' })
            setUserId(res.data.data._id.$id)
            setUserType('employee')
            setUserName(res.data.data.user_lastName + res.data.data.user_givenName)
            this.$router.push('/employeelist')
          } else {
            this.$message.warning(res.data.msg || 'Login failed')
          }
        })
      }
    },
    submitWithPassword() {
      if (this.form.type === '讲师') {
        loginByEducator(this.form.account_name, this.form.account_pwd).then(res => {
          if (res.data.code == 0) {
            this.$message({ message: 'login success', type: 'success' })
            setUserId(res.data.data._id.$id)
            setUserName(res.data.data.educator_first_name + res.data.data.educator_last_name)
            setUserType('educator')
            this.$router.push('/teacherlist')
          } else {
            this.$message.warning('login fail')
          }
        })
      } else if (this.form.type === '学生') {
        loginByStudent('AM', this.form.account_name, this.form.account_pwd).then(res => {
          if (res.data.code == 0) {
            this.handleStudentLoginSuccess(res.data.data)
          } else {
            this.$message.warning('Login failed: ' + res.data.msg)
          }
        })
      } else if (this.form.type === '助教') {
        loginByEmployee(this.form.account_name, this.form.account_pwd).then(res => {
          if (res.data.code == 0) {
            this.$message({ message: 'login success', type: 'success' })
            setUserId(res.data.data._id.$id)
            setUserType('employee')
            setUserName(res.data.data.user_lastName + res.data.data.user_givenName)
            this.$router.push('/employeelist')
          } else {
            this.$message.warning('login fail')
          }
        })
      }
    }
  }
}
</script>

<style lang="less">

.loginBackImg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  align-items: center;
  right: 0;
}
.loginLogo {
  width: 30%;
  position: absolute;
  top: 70px;
  align-items: center;
  left: 35%;
}
.login-title {
  color: #273161;
  font-size: 0.728vw;
  font-weight: 400;
  font-family: "PingFang SC";
}
.login-input {
  margin-top: 2px;
  box-sizing: border-box;
  border: 0px solid transparent;
  border-bottom-width: 2px;
  border-bottom-color:#273161;
  color: #273161;
  font-size: 1.1vw;
  width: 100%;
  height: 3vw;
  background-color: transparent;
  outline: none;
  border-radius: 0px;
  padding: 0 40px;
}
.login-input1 {
  margin-top: 2px;
  box-sizing: border-box;
  border: 0px solid transparent;
  border-bottom-width: 2px;
  border-bottom-color:#273161;
  color: #273161;
  font-size: 1.1vw;
  width: 100%;
  height: 3vw;
  background-color: transparent;
  outline: none;
  border-radius: 0px;
  padding: 0 0 0 25px;
}
.login-method {
  margin-top: 8px;
  .el-radio-group {
    display: flex;
    gap: 20px;
  }
  .el-radio {
    color: #273161;
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #273161;
    background: #273161;
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #273161;
  }
}
.otp-input-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  .otp-input {
    flex: 1;
    width: auto;
  }
  .send-code-btn {
    flex-shrink: 0;
    height: 3vw;
    font-size: 0.728vw;
    border: none;
    background-color: #273161;
    color: white;
    border-radius: 4px;
    padding: 0 15px;
    cursor: pointer;
    &:hover {
      background-color: #072D76;
    }
    &.is-disabled {
      background-color: #8b95b5;
      cursor: not-allowed;
    }
  }
}
.loginInput {
  background-color: transparent;
}

.el-select-dropdown__item.selected {
  color: #F18601;
  font-weight: 700;
}
.el-select{
    width: 100%;
    color: #273161;
    display: inline-block;
    input{
        font-size: 1.1vw;
        border: none;
        background: none;
        text-align: left;
        color: #273161;
    }
    .el-input__suffix{
        i{
            color: transparent;
            margin-left: 0.06rem;
            font-weight: bold;
        }
    }
    ::-webkit-input-placeholder {
        color: transparent;
        font-weight: bold;
    }
}


</style>
